// Token Id
export const SET_TOKEN_ID = 'SET_TOKEN_ID';



// WEBPACK FOOTER //
// ./src/store/reducers/tokenId/actionTypes.js